import React from 'react';
import { Translate } from '../../WithTranslate';
import { ContextMenu2, ContextMenu2ContentProps } from '@blueprintjs/popover2';
import { ToolboxToolsMenu } from './ToolboxToolsMenu';

export interface CalendarContextToolboxProps {
  bpCount: number;
  bpMax: number;
  isSecretariat: boolean;
  onTypeClicked: (contextMenu2ContentProps: ContextMenu2ContentProps) => (type: any) => void;
  onClose: () => void;
  selectedType: any;
  translate: Translate;
  onTransfertDuty?: (contextMenu2ContentProps: ContextMenu2ContentProps) => () => void;
  disabled: boolean;
  children: JSX.Element | JSX.Element[];
}

export const CalendarContextToolbox = ({
  bpCount,
  bpMax,
  isSecretariat,
  onTypeClicked,
  onClose,
  selectedType,
  translate,
  onTransfertDuty,
  disabled,
  children,
}: CalendarContextToolboxProps) => {
  return (
    <ContextMenu2
      content={(contextMenu2ContentProps: ContextMenu2ContentProps) =>
        ToolboxToolsMenu({
          ...contextMenu2ContentProps,
          blackPointHolidayCount: bpCount,
          blackPointHolidayMax: bpMax,
          isSecretariat: isSecretariat,
          onTypeClicked: (type) => {
            onTypeClicked(contextMenu2ContentProps)(type);
            document.body.style.overflowX = 'auto';
            document.body.style.overflowY = 'auto';
          },
          onClose: () => {
            onClose();
            document.body.style.overflowX = 'auto';
            document.body.style.overflowY = 'auto';
          },
          selectedType: selectedType,
          translate: translate,
          onTransfertDuty: onTransfertDuty !== undefined ? onTransfertDuty(contextMenu2ContentProps) : undefined,
        })
      }
      disabled={disabled}
      popoverProps={{
        onOpened: () => {
          document.body.style.overflowX = 'hidden';
          document.body.style.overflowY = 'hidden';
        }
      }}
    >
      {children}
    </ContextMenu2>
  );
};
